interface TabProps {
  children: React.ReactNode;
}
const Tab = ({
  children
}: TabProps) => <span className="relative z-10 flex items-center justify-center gap-2 font-heading font-semibold text-gray-950 text-xl leading-none dark:text-white" data-sentry-component="Tab" data-sentry-source-file="Tab.tsx">
    {children}
  </span>;
export default Tab;